import toNumber from "lodash/toNumber";

type TruthyCondition<T extends unknown> = T;
type FalsyCondition<T extends unknown> = T;
type TupleWithCollections<T> = [T[], T[]];
type ActionWithCondition<T> = (value: T, index?: number) => boolean;

function conditionalReducer<T>(
  condition: ActionWithCondition<T>,
  acc: [FalsyCondition<T>[], TruthyCondition<T>[]],
  item: T,
  index: number
) {
  const conditionResult: boolean = condition(item, index);

  const arrayIndex = toNumber(conditionResult);
  acc[arrayIndex].push(item);

  return acc;
}

export function splitArrayByCondition<T>(
  this: any,
  items: Array<T>,
  condition: ActionWithCondition<T>
): TupleWithCollections<T> {
  const emptyCollections: TupleWithCollections<T> = [[], []];
  const createTuple = conditionalReducer.bind<T, any, any>(this, condition);

  return items.reduce<TupleWithCollections<T>>(createTuple, emptyCollections);
}
